var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L4 4.66667M4 4.66667L2 10.6667C2.57713 11.0994 3.27901 11.3333 4.00033 11.3333C4.72166 11.3333 5.42353 11.0994 6.00067 10.6667M4 4.66667L6 10.6667M4 4.66667L8 3.33333M8 3.33333L12 4.66667M8 3.33333V2M8 3.33333V14M12 4.66667L14 4M12 4.66667L10 10.6667C10.5771 11.0994 11.279 11.3333 12.0003 11.3333C12.7217 11.3333 13.4235 11.0994 14.0007 10.6667L12 4.66667ZM8 14H6M8 14H10",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleOutline);
export default __webpack_public_path__ + "static/media/ScaleOutline.c8e64eba8454bd26232beaa759dd061c.svg";
export { ForwardRef as ReactComponent };